
import api from "../utils/api";

export const updatePassword = async (username, oldPassword, newPassword, confirmPassword) => {
  try {
    const response = await api.post("/change_password", {
      username,
      old_password: oldPassword,
      new_password: newPassword,
      confirm_password: confirmPassword,
    });
    return response.data;
  } catch (error) {
    console.error("Update password error:", error);
    throw error;
  }
};

export const updateEmail = async (username, currentEmail, newEmail) => {
  try {
    const response = await api.post("/change_email", {
      username,
      current_email: currentEmail,
      new_email: newEmail,
    });
    return response.data;
  } catch (error) {
    console.error("Update email error:", error);
    throw error;
  }
};

export const updatePhone = async (username, countryCode, phoneNumber) => {
  try {
    const response = await api.post("/update_phone", {
      username,
      country_code: countryCode,
      phone_number: phoneNumber,
    });
    return response.data;
  } catch (error) {
    console.error("Update phone error:", error);
    throw error;
  }
};

export const updateConsumerInfo = async (username, consumerId, sanctionedLoad) => {
  try {
    const response = await api.post("/update_customer_info", {
      username,
      consumer_id: consumerId,
      sanctioned_load: sanctionedLoad,
    });
    return response.data;
  } catch (error) {
    console.error("Update consumer info error:", error);
    throw error;
  }
};

export const updateUnitPrices = async (username, unitPrice, genUnitPrice, solarUnitPrice) => {
  try {
    const payload = { username };
    if (unitPrice) payload.unit_price = unitPrice;
    if (genUnitPrice) payload.gen_unitprice = genUnitPrice;
    if (solarUnitPrice) payload.solar_unitprice = solarUnitPrice;

    const response = await api.post("/update_unit_price", payload);
    return response.data;
  } catch (error) {
    console.error("Update unit prices error:", error);
    throw error;
  }
};

export const getConsumerInfo = async (username) => {
  try {
    const response = await api.get(`/get_customer_info?username=${encodeURIComponent(username)}`);
    return response.data;
  } catch (error) {
    console.error("Get consumer info error:", error);
    throw error;
  }
};
